"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.catching = exports.delay = exports.cancellableWait = exports.wait = void 0;
/**
 * 一定時間待機する promise を返す
 * @param  duration [description]
 * @return          [description]
 */
function wait(duration) {
    return new Promise(function (resolve) {
        setTimeout(function () { return resolve(); }, duration);
    });
}
exports.wait = wait;
/**
 * 一定時間待機する promise およびそのキャンセル処理を返す
 * @param  duration 待機する時間（ミリ秒）
 * @param  repeat   キャンセル完了最大遅延時間（ミリ秒）
 * @return          [description]
 */
function cancellableWait(duration, repeat) {
    if (repeat === void 0) { repeat = 10; }
    var canceled = false;
    var cancel = function () {
        canceled = true;
    };
    var limit = Math.floor(duration / repeat);
    var promise = new Promise(function (resolve, reject) {
        var count = 0;
        var id = setInterval(function () {
            if (++count > limit) {
                clearInterval(id);
                resolve();
            }
        }, repeat);
        cancel = function (silent) {
            if (canceled) {
                return;
            }
            canceled = true;
            clearInterval(id);
            if (silent === true) {
                resolve();
            }
            else {
                reject(new Error("wait canceled"));
            }
        };
    });
    return [promise, cancel];
}
exports.cancellableWait = cancellableWait;
/**
 * promise の成功時間が duration より早ければ遅延させる
 * fluctuation の割合だけ待ち時間が変動する。
 */
var delay = function (duration, fluctuation) { return function (promise) { return __awaiter(void 0, void 0, void 0, function () {
    var wt, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                wt = duration * (1 + (Math.random() * (fluctuation || 0)) / 100);
                return [4 /*yield*/, Promise.all([promise, wait(wt)])];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res[0]];
        }
    });
}); }; };
exports.delay = delay;
var catching = function (p) {
    return p
        .then(function (t) { return [t, undefined]; })
        .catch(function (e) { return [undefined, e]; });
};
exports.catching = catching;
